import Head from 'expo-router/head';

import { Pypestream } from '@fhs-legacy/frontend/src/pages/pypestream/pypestream';

export default function PypestreamPage() {
  return (
    <>
      <Head>
        <title>Support Chat - Firehouse Subs</title>
      </Head>
      <Pypestream />
    </>
  );
}
